module.exports = __webpack_public_path__ + "img/1537213386.940834b8.jpg";